import Services from '../../services'

const state = {
  isShowForecastModal: false,
  forecastModalData: null,
  forecastPrediction: null,
  lockedTokens: 0,
  acceptedRules: false,
};

// getters
const getters = {
  isShowForecastModal: state => state.isShowForecastModal,
  forecastModalData: state => state.forecastModalData,
  lockedTokens: state => state.lockedTokens,
  acceptedRules: state => state.acceptedRules,
  forecastPrediction: state => state.forecastPrediction,
};

// actions
const actions = {
};

// mutations
const mutations = {
  setShowForecastModal(state, status) {
    state.isShowForecastModal = status;
  },
  setForecastModalData(state, data) {
    state.forecastModalData = data;
  },
  setPrediction(state, prediction) {
    state.forecastPrediction = prediction;
  },
  setLockedTokens(state, tokens) {
    state.lockedTokens = tokens;
  },
  setAcceptedRules(state, rules) {
    state.acceptedRules = rules;
  },
  clearForecastModalData(state) {
    state.forecastModalData = null;
    state.forecastPrediction = null;
    state.lockedTokens = 0;
    state.acceptedRules = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/forecast.js